module.exports = __webpack_public_path__ + "static/media/mesonry-lg-3.269c71f6.jpg";